import React from "react";
import Chart from "react-apexcharts";

const OnboardingGraph = () => {
  const chartOptions = {
    chart: {
      type: "donut",
      height: 380,
    },

    labels: ["Complete", "Decline", "Pending", "Exit"],
    colors: ["#1F8A34", "#D93636", "#F4B000", "#C55A2D"],

    legend: {
      show: false,
    },

    stroke: {
      width: 8,
      colors: ["#fff"],
    },

    plotOptions: {
      pie: {
        donut: {
          size: "50%",
          background: "transparent",

          labels: {
            show: true,
            total: {
              show: true,
            },
            value: {
              show: false,
            },
            name: {
              show: true,
              formatter: () => "",
            },
          },
        },
      },
    },

    dataLabels: {
      enabled: false,
    },
  };

  const chartSeries = [10, 2, 5, 3];

  const legendItems = [
    { label: "Complete", color: "#1F8A34", value: "10" },
    { label: "Decline", color: "#D93636", value: "02" },
    { label: "Pending", color: "#F4B000", value: "05" },
    { label: "Exit", color: "#C55A2D", value: "03" },
  ];

  return (
    <div className="onboarding-graph-wrapper">
      <h5>GRAPH</h5>

      <div className="graph-section">
        <div className="chart-box">
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="donut"
            height={380}
            width={380}
          />
        </div>

        {/* CUSTOM LEGEND */}
        <div className="legend-box">
          {legendItems.map((item, index) => (
            <div className="legend-row" key={index}>
              <div className="legend-left">
                <span
                  className="legend-color"
                  style={{ background: item.color }}
                ></span>
                <span className="legend-label">{item.label}</span>
              </div>
              <span className="legend-value">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OnboardingGraph;
